
export default class AppConfigFeatures {
  invitationCodes = false;
  organizationAccessCodes: { enabled?: boolean, accessCodeUrlBase?: string } = {};
  externalAuthProviders: { microsoftLoginEnabled?: boolean, googleLoginEnabled?: boolean } = {};

  static fromApi(data: AppConfigFeatures) {
    const model = new AppConfigFeatures();
    model.invitationCodes = data.invitationCodes ? true : false;
    model.organizationAccessCodes = data.organizationAccessCodes;
    model.externalAuthProviders = data.externalAuthProviders;
    return model;
  }
}